import {useQuery} from '@tanstack/react-query';
import {HealthDistrictsGuide} from 'domain/usecases/private/guide-flow/medical-guide/get-districts';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {UseHealthDistrictsGuideQueryParams} from './types';
import {getHealthDistrictsGuide} from '../../services/getHealthDistrictsGuide';

export function useHealthDistrictsGuideQuery(params: UseHealthDistrictsGuideQueryParams) {
	const {cdUf, nmCidade, coordenadas, enabled = true} = params;

	const condition = (Boolean(cdUf && nmCidade) || Boolean(coordenadas)) && enabled;

	return useQuery<HealthDistrictsGuide[]>({
		queryKey: [QUERY_KEYS.HEALTH_DISTRICTS_GUIDE, {cdUf, nmCidade, coordenadas, ...params}],
		queryFn: ({signal}) =>
			getHealthDistrictsGuide({
				...(coordenadas === undefined && {cdUf}),
				...(coordenadas === undefined && {nmCidade}),
				...(coordenadas !== undefined && {coordenadas}),
				dsEspecialidade: params.dsEspecialidade || '',
				dsTipo: params.dsTipo || '',
				nmPrestador: params.nmPrestador || '',
				tpRede: params.tpRede || '',
				signal,
			}),
		enabled: condition,
	});
}
